<template>
  <h1 style="font-size: 3em; font-weight: 400; margin-top: 0;">Insights & Perspectives</h1>
  <div class="custom-swiper-wrapper">
    <a
        v-for="(card, index) in cards"
        :key="index"
        :href="card.link"
        target="_blank"
        class="card card-slide"
        role="group"
        :aria-label="`${index + 1} / ${cards.length}`"
    >
      <div class="card__image">
        <picture>
          <img :src="card.image" class="card__img"/>
        </picture>
      </div>
      <div class="card__content">
        <div class="card__header">
          <span class="badge">{{ card.badge }}</span>
          <h2 class="card__title">{{ card.title }}</h2>
        </div>
        <div class="card__cta">
          <span class="arrow-icon" aria-hidden="true">
            <!-- SVG icon -->
            <svg xmlns="http://www.w3.org/2000/svg" class="arrow-svg" width="24" height="24" fill="currentColor"
                 viewBox="0 0 24 24">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M16.5805 11.0058L12.2904 6.71885C11.8904 6.31915 11.8904 5.68961 12.2894 5.2999C12.6794 4.9002 13.3094 4.9002 13.7094 5.2989L19.7094 11.2945C19.9603 11.5388 20.0498 11.8907 19.9778 12.2144C19.9264 12.453 19.789 12.6607 19.6 12.8032L13.6995 18.6992C13.5095 18.8791 13.2495 18.989 12.9895 18.989L12.9995 19C12.7295 19 12.4695 18.8901 12.2895 18.7102C11.8895 18.3205 11.8895 17.681 12.2795 17.2913V17.2813L16.5596 13.0043H5C4.44 13.0043 4 12.5547 4 12.0051C4 11.4455 4.44 11.0058 5 11.0058H16.5805Z"/>
            </svg>
          </span>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cards: [
        {
          link: 'https://www.broadridge.com/_assets/pdf/broadridge-a-valuable-offering-for-clients-a-competitive-edge-for-advisors.pdf',
          image: require('@/assets/card_1.jpg'),
          badge: 'RESOURCE',
          title: 'Securities-Based Lending: A Valuable Offering for Clients, a Competitive Edge for Advisors | Broadridge'
        },
        {
          link: 'https://www.broadridge.com/resource/wealth-management/a-short-sbl-training-program',
          image: require('@/assets/card_2.jpg'),
          badge: 'RESOURCE',
          title: 'Our SBL Training Program'
        },
        {
          link: 'https://www.broadridge.com/_assets/pdf/broadridge-sbl-checklist-static-v1.pdf',
          image: require('@/assets/card_3.jpg'),
          badge: 'RESOURCE',
          title: 'SBL Wealth Management Insight | Broadridge'
        }
      ]
    };
  }
};
</script>

<style scoped>
.custom-swiper-wrapper {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  overflow-x: auto;
  gap: 40px;
}

.card-slide {
  display: flex;
  flex-direction: column;
  background-color: #001F5A;
  color: white;
  width: 300px;
  text-decoration: none;
  border-radius: 8px;
  min-height: 500px;
  overflow: hidden;
  transition: background-color 0.3s ease;
}

.card-slide:hover {
  background-color: #040c34;
}

.card__image img {
  width: 100%;
  height: auto;
  object-fit: cover;
  aspect-ratio: 3 / 2;
}

.card__content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.card__header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.badge {
  background-color: #0f3db5;
  color: white;
  font-size: 14px;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  width: fit-content;
}

.card__title {
  font-size: 24px;
  font-weight: 400;
  line-height: 1.15;
}

.card__cta {
  margin-top: auto;
  display: flex;
  justify-content: flex-start;
}

.arrow-icon {
  display: inline-block;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform: translateX(0);
  opacity: 0.8;
}

.card-slide:hover .arrow-icon {
  transform: translateX(6px);
  opacity: 1;
}
</style>
